import React, { useEffect, useRef, useState } from 'react';
import './style.sass';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Controller } from 'react-hook-form';
import { ButtonsCollection, FormsCollection } from '../../../../../ui-kit';


const DELAY = 800;

/**
 *
 * @param values{Object}
 * @param pending{boolean}
 * @param leaves{Object}
 * @param control{Object}
 * @param renderEmailNotificationBlock(function)
 * @returns {JSX.Element}
 * @constructor
 */

export const FormProfile = ({
  user,
  pending,
  leaves,
  control,
  renderEmailNotificationBlock,
}) => {
  const [isDisabled, setIsDisabled] = useState(null);
  const { t } = useTranslation('common');
  const history = useHistory();
  const goToPreviousPath = () => {
    history.goBack();
  };
  const onRemoveDisabled = () => {
    setIsDisabled(false);
  };

  const privateRef = useRef({ pending });

  useEffect(() => {
    privateRef.current = { pending };
  }, [pending]);

  const prevProps = privateRef.current;

  useEffect(() => {
    if (pending && prevProps.pending !== pending) {
      setIsDisabled(true);
    }
  }, [pending, prevProps]);

  return (
    <div className="form-profile">
      <div className="form-profile__row">
        <Controller
          name="first_name"
          control={control}
          defaultValue={user?.first_name || ''}
          render={({
            touched = true, field: { onChange, value, onBlur }, fieldState: { error },
          }) => (
            <FormsCollection.Input
              name="first_name"
              value={value}
              error={error?.message.message}
              disabled={isDisabled}
              onChange={onChange}
              onBlur={onBlur}
              touched={touched}
              id="form-profile__field-first-name"
              placeholderJump="First name"
            />
          )}
        />
      </div>
      <div className="form-profile__row">
        <Controller
          name="last_name"
          control={control}
          defaultValue={user?.last_name || ''}
          render={({
            touched = true, field: { onChange, value, onBlur }, fieldState: { error },
          }) => (
            <FormsCollection.Input
              name="last_name"
              value={value}
              error={error?.message.message}
              onBlur={onBlur}
              touched={touched}
              disabled={isDisabled}
              onChange={onChange}
              id="form-profile__field-last-name"
              placeholderJump="Last name"
            />
          )}
        />
      </div>
      <div className="form-profile__row">
        <Controller
          name="username"
          control={control}
          defaultValue={user?.username || ''}
          render={({
            touched = true, field: { onChange, value, onBlur }, fieldState: { error },
          }) => (
            <FormsCollection.Input
              name="username"
              disabled={isDisabled}
              value={value}
              error={error?.message.message}
              onBlur={onBlur}
              touched={touched}
              onChange={onChange}
              id="form-profile__field-user-name"
              placeholderJump="Username"
            />
          )}
        />
      </div>
      {renderEmailNotificationBlock()}
      <div className="form-profile__days-left">
        <span className="form-profile__days-left-title">{t('Days left')}</span>
        <div className="form-profile__days-left-row">
          <div className="form-profile__block--vacation">
            <span className="form-profile__label">{t('Vacation')}</span>
            <span className="form-profile__leaves-value">
              <span className="form-profile__leaves-number">{leaves ? leaves.vacation : '...'}</span>
              {t('days')}
            </span>
          </div>
          <div className="form-profile__block--leaves">
            <span className="form-profile__label">{t('Sick leave')}</span>
            <span className="form-profile__leaves-value">
              <span className="form-profile__leaves-number">{leaves ? leaves.sick_leave : '...'}</span>
              {t('days')}
            </span>
          </div>
        </div>
        <div className="form-profile__days-left-note">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7.25" stroke="currentColor" strokeWidth="1.5" />
            <path d="M8 7.25V11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="8" cy="4.75" r="1" fill="currentColor" />
          </svg>
          <span>{t('These values are updated once every 24 hours')}</span>
        </div>
      </div>
      <div className="form-profile__row form-profile__row--buttons">
        <ButtonsCollection.ButtonBrill
          type="submit"
          pending={pending}
          delay={DELAY}
          onEndDelay={onRemoveDisabled}
          className="button-brill--fill form-profile__control-button form-profile__submit-button button--md"
        >
          {t('Save')}
        </ButtonsCollection.ButtonBrill>
        <button
          type="button"
          onClick={goToPreviousPath}
          className="form-profile__cancel-button form-profile__control-button"
        >
          {t('Cancel')}
        </button>
      </div>
    </div>
  );
};
